import { createSelector } from 'reselect';
import { State } from 'store';

// Raw store selectors
const getSystemState = (state: State) => state.system;
export const getSystemConfig = createSelector(getSystemState, system => system.config);
export const getSystemInitialized = createSelector(getSystemState, system => system.initialized);
export const getSystemTheme = createSelector(getSystemState, system => system.theme);
export const getSystemUnauthorized = createSelector(getSystemState, system => system.unauthorized);
